import React, {useEffect} from "react";
import {Helmet} from "react-helmet";
import $ from 'jquery';
import jQuery from 'jquery';
import './Components/jquery-imports-setup';
import {BasicImportCss} from "./Components/BasicImportCss";
import {NavBar} from "./Components/NavBar";
import {Footer} from "./Components/Footer";


export const ProductLager = (effect, deps) => {

    return (
        <React.Fragment>

            <BasicImportCss/>

            <div className="wrapper" style={{display: "none"}}>

                <NavBar/>

                <section className="main-header text-center" style={{backgroundImage: 'url(assets/images/gallery-2.jpg)'}}>
                    <header>
                        <div className="container">
                            <h1 className="h2 title">Product category</h1>
                            <ol className="breadcrumb breadcrumb-inverted">
                                <li>
                                    <a href="index.html"><span className="icon icon-home"></span></a>
                                </li>
                                <li>
                                    <a href="category.html">Product Category</a>
                                </li>
                                <li>
                                    <a href="products-grid.html">Product Sub-category</a>
                                </li>
                                <li>
                                    <a className="active" href="product.html">Product overview</a>
                                </li>
                            </ol>
                        </div>
                    </header>
                </section>


                <section className="product">
                    <div className="main">
                        <div className="container">
                            <div className="row product-flex">


                                <div className="col-md-4 col-sm-12 product-flex-info">
                                    <div className="clearfix">


                                        <h1 className="title" data-title="Wireless">
                                            Headphones Wireless
                                            <small>Free shipping</small>
                                        </h1>

                                        <div className="clearfix">


                                            <div className="price">
                                        <span className="h3">
                                            $ 1999,00
                                            <small>$ 2999,00</small>
                                        </span>
                                            </div>
                                            <hr/>


                                            <div className="info-box">
                                                <span><strong>Maifacturer</strong></span>
                                                <span>Brand name</span>
                                            </div>


                                            <div className="info-box">
                                                <span><strong>Materials</strong></span>
                                                <span>Wood, Leather, Acrylic</span>
                                            </div>


                                            <div className="info-box">
                                                <span><strong>Availability</strong></span>
                                                <span><i className="fa fa-check-square-o"></i> In stock</span>
                                                <span className="hidden"><i className="fa fa-truck"></i> Out of stock</span>
                                            </div>

                                            <hr/>

                                            <div className="info-box info-box-addto added">
                                        <span>
                                            <i className="add"><i className="fa fa-heart-o"></i> Add to favorites</i>
                                            <i className="added"><i className="fa fa-heart"></i> Remove from favorites</i>
                                        </span>
                                            </div>

                                            <div className="info-box info-box-addto">
                                        <span>
                                            <i className="add"><i className="fa fa-eye-slash"></i> Add to Watch list</i>
                                            <i className="added"><i className="fa fa-eye"></i> Remove from Watch list</i>
                                        </span>
                                            </div>

                                            <div className="info-box info-box-addto">
                                        <span>
                                            <i className="add"><i className="fa fa-star-o"></i> Add to Collection</i>
                                            <i className="added"><i className="fa fa-star"></i> Remove from Collection</i>
                                        </span>
                                            </div>

                                            <hr/>


                                            <div className="info-box">
                                                <span><strong>Available Colors</strong></span>
                                                <div className="product-colors clearfix">
                                                    <span className="color-btn color-btn-red"></span>
                                                    <span className="color-btn color-btn-blue checked"></span>
                                                    <span className="color-btn color-btn-green"></span>
                                                    <span className="color-btn color-btn-gray"></span>
                                                    <span className="color-btn color-btn-biege"></span>
                                                </div>
                                            </div>


                                            <div className="info-box">
                                                <span><strong>Choose size</strong></span>
                                                <div className="product-colors clearfix">
                                            <span className="color-btn color-btn-biege">
                                                <span className="product-size" data-text="">S</span>
                                            </span>
                                                    <span className="color-btn color-btn-biege checked">M</span>
                                                    <span className="color-btn color-btn-biege">XL</span>
                                                    <span className="color-btn color-btn-biege">XXL</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-8 col-sm-12 product-flex-gallery">


                                    <button type="submit" className="btn btn-buy" data-text="Buy"></button>


                                    <div className="owl-product-gallery open-popup-gallery">
                                        <a href="assets/images/product-10.png"><img src="assets/images/product-10.png"
                                                                                    alt="" height="500"/></a>
                                        <a href="assets/images/product-10a.png"><img src="assets/images/product-10a.png"
                                                                                     alt="" height="500"/></a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div className="info">
                        <div className="container">
                            <div className="row">


                                <div className="col-md-3">
                                    <div className="brands">
                                        <div className="box">
                                            <div className="image">
                                                <img src="assets/images/logo-2.png" alt="Alternate Text"/>
                                            </div>
                                            <div className="name">
                                                <p>Brand name</p>
                                                <p><a href="#">Brand Url</a></p>
                                                <p><a href="#">More about brand</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-9">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li role="presentation" className="active">
                                            <a href="#about" aria-controls="about" role="tab" data-toggle="tab">
                                                <i className="icon icon-history"></i>
                                                <span>About</span>
                                            </a>
                                        </li>
                                        <li role="presentation">
                                            <a href="#specs" aria-controls="specs" role="tab" data-toggle="tab">
                                                <i className="icon icon-sort-alpha-asc"></i>
                                                <span>Specification</span>
                                            </a>
                                        </li>
                                        <li role="presentation">
                                            <a href="#rating" aria-controls="rating" role="tab" data-toggle="tab">
                                                <i className="icon icon-thumbs-up"></i>
                                                <span>Rating</span>
                                            </a>
                                        </li>
                                    </ul>


                                    <div className="tab-content">


                                        <div role="tabpanel" className="tab-pane active" id="about">
                                            <div className="product-content">
                                                <h3>About this Item</h3>
                                                <p>
                                                    While we aim to provide accurate product information, it is provided
                                                    by manufacturers, suppliers and others, and has not been verified by
                                                    us. See our disclaimer.
                                                    The beauty of the Q7C arc is a visual spectacle. Equipped with the
                                                    features of the Q7 Flat, but with a bend for immersive viewing, it
                                                    combines Q Color and an anti-glare screen for a dazzling display
                                                    unlike any other.
                                                    Brandname 65" Class 4K(2160P) Curved Smart QLED TV QN65Q7CN (2018
                                                    Model)
                                                </p>

                                                <hr/>

                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <h3>Key Features</h3>
                                                        <ul>
                                                            <li>Diagonal Screen Size: 64.5"</li>
                                                            <li>Backlight Type: QLED</li>
                                                            <li>Resolution: 2160P</li>
                                                            <li>Effective Refresh Rate: 240Hz</li>
                                                            <li>Smart Functionality: yes</li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <h3>Connectivity</h3>
                                                        <ul>
                                                            <li>HDMI Inputs: yes, 4</li>
                                                            <li>USB Ports: yes, 3</li>
                                                            <li>Built-in Wi-Fi: yes</li>
                                                            <li>Stereo speakers: yes</li>
                                                            <li>Bluetooth: yes</li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <h3>Style Elite</h3>
                                                        <ul>
                                                            <li>One invisible connection</li>
                                                            <li>One Connect Box</li>
                                                            <li>No gap wall mount</li>
                                                            <li>Ultra wide viewing angle</li>
                                                            <li>Ambient mode</li>
                                                            <li>Boundless 360 design</li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>


                                        <div role="tabpanel" className="tab-pane" id="specs">
                                            <div className="product-content">
                                                <h3>Specification</h3>
                                                <table className="table table-striped specification">
                                                    <tbody>
                                                    <tr>
                                                        <th>Model</th>
                                                        <td>
                                                            <div>QN65Q7CNAFXZA</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Screen Size</th>
                                                        <td>
                                                            <div>65\"</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Brand</th>
                                                        <td>
                                                            <div>Brandname</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Assembled Product Weight</th>
                                                        <td>
                                                            <div>87.1 oz</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Condition</th>
                                                        <td>
                                                            <div>New</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>ID</th>
                                                        <td>
                                                            <div>qn65q7cnafxza</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Dimensions (L x W x H)</th>
                                                        <td>
                                                            <div>8.30 x 63.70 x 37.80 Inches</div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>


                                        <div role="tabpanel" className="tab-pane" id="rating">


                                            <div className="product-content">

                                                <h3>Rating</h3>

                                                <div className="row">


                                                    <div className="col-md-12">
                                                        <div className="comments">


                                                            <div className="rating clearfix">
                                                                <div className="rate-box">
                                                                    <strong>Quality</strong>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>3</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>5</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>0</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>2</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>1</span>
                                                                    </div>
                                                                </div>


                                                                <div className="rate-box">
                                                                    <strong>Design</strong>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <span>3</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <span>5</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <span>0</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>2</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star active"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>1</span>
                                                                    </div>
                                                                </div>


                                                                <div className="rate-box">
                                                                    <strong>General</strong>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>3</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>5</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>0</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>2</span>
                                                                    </div>
                                                                    <div className="rating">
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <i className="fa fa-star"></i>
                                                                        <span>1</span>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="comment-wrapper">


                                                                <div className="comment-block">
                                                                    <div className="comment-user">
                                                                        <div>
                                                                            <img src="assets/images/user-2.jpg"
                                                                                 alt="Alternate Text" width="70"/>
                                                                        </div>
                                                                        <div>
                                                                            <h5>
                                                                                <span>John Doe</span>
                                                                                <span className="pull-right">
                                                                            <i className="fa fa-star active"></i>
                                                                            <i className="fa fa-star active"></i>
                                                                            <i className="fa fa-star active"></i>
                                                                            <i className="fa fa-star active"></i>
                                                                            <i className="fa fa-star"></i>
                                                                        </span>
                                                                                <small>03.05.2017</small>
                                                                            </h5>
                                                                        </div>
                                                                    </div>


                                                                    <div className="comment-desc">
                                                                        <p>
                                                                            In vestibulum tellus ut nunc accumsan
                                                                            eleifend. Donec mattis cursus ligula, id
                                                                            iaculis dui feugiat nec. Etiam ut ante sed
                                                                            neque lacinia volutpat. Maecenas
                                                                            ultricies tempus nibh, sit amet facilisis
                                                                            mauris vulputate in. Phasellus
                                                                            tempor justo et mollis facilisis. Donec
                                                                            placerat at nulla sed suscipit. Praesent
                                                                            accumsan, sem sit amet euismod ullamcorper,
                                                                            justo sapien cursus nisl, nec
                                                                            gravida
                                                                        </p>
                                                                    </div>


                                                                    <div className="comment-block">
                                                                        <div className="comment-user">
                                                                            <div>
                                                                                <img src="assets/images/user-2.jpg"
                                                                                     alt="Alternate Text" width="70"/>
                                                                            </div>
                                                                            <div>
                                                                                <h5>
                                                                                    Administrator
                                                                                    <small>08.05.2017</small>
                                                                                </h5>
                                                                            </div>
                                                                        </div>
                                                                        <div className="comment-desc">
                                                                            <p>
                                                                                Curabitur sit amet elit quis tellus
                                                                                tincidunt efficitur. Cras lobortis id
                                                                                elit eu vehicula. Sed porttitor nulla
                                                                                vitae nisl varius luctus. Quisque
                                                                                a enim nisl. Maecenas facilisis, felis
                                                                                sed blandit scelerisque, sapien
                                                                                nisl egestas diam, nec blandit diam
                                                                                ipsum eget dolor. Maecenas ultricies
                                                                                tempus nibh, sit amet facilisis mauris
                                                                                vulputate in.
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                <div className="comment-block">
                                                                    <div className="comment-user">
                                                                        <div>
                                                                            <img src="assets/images/user-2.jpg"
                                                                                 alt="Alternate Text" width="70"/>
                                                                        </div>
                                                                        <div>
                                                                            <h5>
                                                                                <span>John Doe</span>
                                                                                <span className="pull-right">
                                                                            <i className="fa fa-star active"></i>
                                                                            <i className="fa fa-star active"></i>
                                                                            <i className="fa fa-star active"></i>
                                                                            <i className="fa fa-star"></i>
                                                                            <i className="fa fa-star"></i>
                                                                        </span>
                                                                                <small>03.05.2017</small>
                                                                            </h5>
                                                                        </div>
                                                                    </div>
                                                                    <div className="comment-desc">
                                                                        <p>
                                                                            Cras lobortis id elit eu vehicula. Sed
                                                                            porttitor nulla vitae nisl varius luctus.
                                                                            Quisque a enim nisl. Maecenas facilisis,
                                                                            felis sed blandit scelerisque, sapien
                                                                            nisl egestas diam, nec blandit diam ipsum
                                                                            eget dolor. In vestibulum tellus
                                                                            ut nunc accumsan eleifend. Donec mattis
                                                                            cursus ligula, id iaculis dui feugiat
                                                                            nec. Etiam ut ante sed neque lacinia
                                                                            volutpat. Maecenas ultricies tempus
                                                                            nibh, sit amet facilisis mauris vulputate
                                                                            in. Phasellus tempor justo et mollis
                                                                            facilisis. Donec placerat at nulla sed
                                                                            suscipit. Praesent accumsan, sem sit
                                                                            amet euismod ullamcorper, justo sapien
                                                                            cursus nisl, nec gravida
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="comment-header">
                                                                <a href="#" className="btn btn-clean-dark">12 comments</a>
                                                            </div>


                                                            <div className="comment-add">

                                                                <div className="comment-reply-message">
                                                                    <div className="h3 title">Leave a Reply</div>
                                                                    <p>Your email address will not be published.</p>
                                                                </div>

                                                                <form action="#" method="post">
                                                                    <div className="form-group">
                                                                        <input type="text" className="form-control"
                                                                               name="name" value=""
                                                                               placeholder="Your Name"/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <input type="text" className="form-control"
                                                                               name="name" value=""
                                                                               placeholder="Your Email"/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <textarea rows="10" className="form-control"
                                                                                  placeholder="Your comment"></textarea>
                                                                    </div>
                                                                    <div className="clearfix text-center">
                                                                        <a href="#" className="btn btn-main">Add comment</a>
                                                                    </div>
                                                                </form>

                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="products">


                    <header>
                        <div className="row">
                            <div className="col-md-offset-2 col-md-8 text-center">
                                <h2 className="title">Best seller</h2>
                                <div className="text">
                                    <p>Check out our latest collections</p>
                                </div>
                            </div>
                        </div>
                    </header>

                    <div className="row row-clean">


                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                            <article>
                                <div className="info">
                            <span className="add-favorite">
                                <a href="javascript:void(0);" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                    <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                                </div>
                                <div className="btn btn-add">
                                    <i className="icon icon-cart"></i>
                                </div>
                                <div className="figure-grid">
                                    <div className="image">
                                        <a href="#productid1" className="mfp-open">
                                            <img src="assets/images/product-7.png" alt="" width="360"/>
                                        </a>
                                    </div>
                                    <div className="text">
                                        <h2 className="title h5">
                                            <a href="product.html">Coffee machine</a>
                                        </h2>
                                        <sub>$ 159,-</sub>
                                        <sup>$ 139,-</sup>
                                        <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                    </div>
                                </div>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                            <article>
                                <div className="info">
                            <span className="add-favorite">
                                <a href="javascript:void(0);" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                    <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                                </div>
                                <div className="btn btn-add">
                                    <i className="icon icon-cart"></i>
                                </div>
                                <div className="figure-grid">
                                    <span className="label label-danger">-50%</span>
                                    <div className="image">
                                        <a href="#productid1" className="mfp-open">
                                            <img src="assets/images/product-8.png" alt="" width="360"/>
                                        </a>
                                    </div>
                                    <div className="text">
                                        <h2 className="title h5">
                                            <a href="product.html">Iron set</a>
                                        </h2>
                                        <sub>$ 1999,-</sub>
                                        <sup>$ 1499,-</sup>
                                        <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                    </div>
                                </div>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                            <article>
                                <div className="info">
                            <span className="add-favorite">
                                <a href="javascript:void(0);" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                    <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                                </div>
                                <div className="btn btn-add">
                                    <i className="icon icon-cart"></i>
                                </div>
                                <div className="figure-grid">
                                    <div className="image">
                                        <a href="#productid1" className="mfp-open">
                                            <img src="assets/images/product-9.png" alt="" width="360"/>
                                        </a>
                                    </div>
                                    <div className="text">
                                        <h2 className="title h5">
                                            <a href="product.html">Projector 4k</a>
                                        </h2>
                                        <sub>$ 1999,-</sub>
                                        <sup>$ 1499,-</sup>
                                        <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                    </div>
                                </div>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                            <article>
                                <div className="info">
                            <span className="add-favorite">
                                <a href="javascript:void(0);" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                    <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                                </div>
                                <div className="btn btn-add">
                                    <i className="icon icon-cart"></i>
                                </div>
                                <div className="figure-grid">
                                    <span className="label label-info">-20%</span>
                                    <div className="image">
                                        <a href="#productid1" className="mfp-open">
                                            <img src="assets/images/product-10.png" alt="" width="360"/>
                                        </a>
                                    </div>
                                    <div className="text">
                                        <h2 className="title h5">
                                            <a href="product.html">Headphones Wireless</a>
                                        </h2>
                                        <sub>$ 1999,-</sub>
                                        <sup>$ 1499,-</sup>
                                        <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                    </div>
                                </div>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                            <article>
                                <div className="info">
                            <span className="add-favorite">
                                <a href="javascript:void(0);" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                    <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                                </div>
                                <div className="btn btn-add">
                                    <i className="icon icon-cart"></i>
                                </div>
                                <div className="figure-grid">
                                    <div className="image">
                                        <a href="#productid1" className="mfp-open">
                                            <img src="assets/images/product-11.png" alt="" width="360"/>
                                        </a>
                                    </div>
                                    <div className="text">
                                        <h2 className="title h5">
                                            <a href="product.html">Vacuum cleaner</a>
                                        </h2>
                                        <sub>$ 1999,-</sub>
                                        <sup>$ 1499,-</sup>
                                        <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                    </div>
                                </div>
                            </article>
                        </div>


                        <div className="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                            <article>
                                <div className="info">
                            <span className="add-favorite">
                                <a href="javascript:void(0);" data-title="Add to favorites"
                                   data-title-added="Added to favorites list"><i className="icon icon-heart"></i></a>
                            </span>
                                    <span>
                                <a href="#productid1" className="mfp-open" data-title="Quick wiew"><i
                                    className="icon icon-eye"></i></a>
                            </span>
                                </div>
                                <div className="btn btn-add">
                                    <i className="icon icon-cart"></i>
                                </div>
                                <div className="figure-grid">
                                    <div className="image">
                                        <a href="#productid1" className="mfp-open">
                                            <img src="assets/images/product-12.png" alt="" width="360"/>
                                        </a>
                                    </div>
                                    <div className="text">
                                        <h2 className="title h5">
                                            <a href="product.html">E-shaver 500</a>
                                        </h2>
                                        <sub>$ 1999,-</sub>
                                        <sup>$ 1499,-</sup>
                                        <span className="description clearfix">Gubergren amet dolor ea diam takimata consetetur facilisis blandit et aliquyam lorem ea duo labore diam sit et consetetur nulla</span>
                                    </div>
                                </div>
                            </article>
                        </div>

                    </div>


                    <div className="wrapper-more">
                        <a href="products-grid.html" className="btn btn-lg">View all</a>
                    </div>


                    <div className="popup-main mfp-hide" id="productid1">


                        <div className="product">


                            <div className="popup-title">
                                <div className="h1 title">
                                    Headphones Wireless
                                    <small>product category</small>
                                </div>
                            </div>


                            <div className="owl-product-gallery">
                                <img src="assets/images/product-10.png" alt="" width="640"/>
                                <img src="assets/images/product-10a.png" alt="" width="640"/>
                            </div>


                            <div className="popup-content">
                                <div className="product-info-wrapper">
                                    <div className="row">


                                        <div className="col-sm-6">
                                            <div className="info-box">
                                                <strong>Maifacturer</strong>
                                                <span>Brand name</span>
                                            </div>
                                            <div className="info-box">
                                                <strong>Materials</strong>
                                                <span>Wood, Leather, Acrylic</span>
                                            </div>
                                            <div className="info-box">
                                                <strong>Availability</strong>
                                                <span><i className="fa fa-check-square-o"></i> in stock</span>
                                            </div>
                                        </div>


                                        <div className="col-sm-6">
                                            <div className="info-box">
                                                <strong>Available Colors</strong>
                                                <div className="product-colors clearfix">
                                                    <span className="color-btn color-btn-red"></span>
                                                    <span className="color-btn color-btn-blue checked"></span>
                                                    <span className="color-btn color-btn-green"></span>
                                                    <span className="color-btn color-btn-gray"></span>
                                                    <span className="color-btn color-btn-biege"></span>
                                                </div>
                                            </div>
                                            <div className="info-box">
                                                <strong>Choose size</strong>
                                                <div className="product-colors clearfix">
                                                    <span className="color-btn color-btn-biege">S</span>
                                                    <span className="color-btn color-btn-biege checked">M</span>
                                                    <span className="color-btn color-btn-biege">XL</span>
                                                    <span className="color-btn color-btn-biege">XXL</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div className="popup-table">
                                <div className="popup-cell">
                                    <div className="price">
                                        <span className="h3">$ 1999,00 <small>$ 2999,00</small></span>
                                    </div>
                                </div>
                                <div className="popup-cell">
                                    <div className="popup-buttons">
                                        <a href="product.html"><span className="icon icon-eye"></span> <span
                                            className="hidden-xs">View more</span></a>
                                        <a href="javascript:void(0);"><span className="icon icon-cart"></span> <span
                                            className="hidden-xs">Buy</span></a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </section>


                <Footer/>

            </div>

        </React.Fragment>
    );
}